<onafriq-modal>
  <div
    class="bg-white md:h-[191px] md:w-[482px] w-[95%] h-fit rounded-2xl p-7.5 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
    style="box-shadow: 0px 4px 28px 0px rgba(0, 47, 56, 0.25)">
    <h2 class="text-gray-900 text-h3">Too many rows to display</h2>
    <p class="mt-4 text-gray-900 text-sm">
      Your request has exceeded the maximum number of records permissible. Please modify your date range selection or
      contact our support team.
    </p>
    <div class="mt-6 flex gap-4 justify-end">
      <onafriq-button type="secondary" label="Cancel" (onClick)="onCancel.emit()" />
      <onafriq-button label="Modify Search" (onClick)="onCancel.emit()" />
    </div>
  </div>
</onafriq-modal>
